import React, { useState, useEffect, useContext } from 'react';
import { AppState } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
// import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { createStackNavigator } from '@react-navigation/stack';
import useWebSocket from 'react-native-use-websocket';
import bcryptjs from 'react-native-bcrypt';

import AsyncStorage from '@react-native-async-storage/async-storage';
import { CredentialsContext } from '../components/CredentialsContext';

import { Entypo, Ionicons} from '@expo/vector-icons';
import { useFonts } from 'expo-font'

// import { socket, reconect} from '../components/Socket';
import SignUp from '../screens/SignUp';
import Home from '../screens/Home';
import ActivationWithSMS from '../screens/ActivationWithSMS';
import FetchRoom from '../screens/FetchRoom';
import Settings from '../screens/Settings';

import MaterialTopTabNav from './MaterialTopTabNav';

import { EnglishStrings } from '../strings/English';
import { PersianStrings } from '../strings/Persian';
import { ArabicStrings } from '../strings/Arabic';

import envVars from '../env';

const Stack = createStackNavigator();

const RootStack = (props) =>{
    const {storedCredentials, setStoredCredentials} = useContext(CredentialsContext);
    const [isTokenValidated, setIsTokenValidated] = useState(true)
    const [token, setToken] = useState('')

    const middleWareServerUrl = envVars.MIDDLE_WARE_SERVER_IP + envVars.MIDDLE_WARE_SERVER_PORT
    const welcomeMsg = {
        CTY: 'mc',
        DID: storedCredentials.userPhoneNumber,
    }

    // const { sendMessage, lastJsonMessage, lastMessage, readyState } = useWebSocket('ws://185.231.115.232:5050', {  
    // const { sendMessage, lastJsonMessage, lastMessage, readyState } = useWebSocket('ws://185.231.115.232:5001', {  
    //     share: true,
    //     onOpen: () => {
    //         sendMessage(JSON.stringify(welcomeMsg))
    //     },
    //     // onOpen: () => {
    //     //     const d = new Date();
    //     //     let time = d.getTime();
    //     //     time = Math.floor(time/1000).toString() + envVars.SECRET
    //     //     const salt = bcryptjs.genSaltSync(10);
    //     //     const hash = bcryptjs.hashSync(time, salt);
    //     //     setToken(hash)

    //     //     const welcomeMsg = {
    //     //         CTY: 'mc',
    //     //         DID: storedCredentials.userPhoneNumber,
    //     //         token: hash
    //     //     }
    //     //     sendMessage(JSON.stringify(welcomeMsg))
    //     // },
    //     retryOnError: true,
    //     // reconnectAttempts: 5,
    //     // reconnectInterval: (attemptNumber) => {
    //     //     Math.min(Math.pow(2, attemptNumber) * 1000, 10000)
    //     // },
    //     shouldReconnect: (CloseEvent) => true,
    // })

    const [fontsLoaded] = useFonts({
        "Mikhak-Bold": require('../assets/Fonts/Mikhak-Bold.ttf')
    })

    useEffect(() => {
        props.navigation.setOptions({
            headerShown: false
        })
    }, [])
    useEffect(()=> {
        if(props.socket.lastMessage.data == 'token validated!'){
            setIsTokenValidated(true)

            AsyncStorage.getItem('flowerCribCredentials').then((storedData)=> {
                storedData = JSON.parse(storedData);
                storedData = {...storedData, ...{token: token}}
                AsyncStorage.setItem('flowerCribCredentials', JSON.stringify(storedData));
                
            })
            .catch((err) => console.log(err))
        } 
    }, [props.socket.lastMessage])

    const strings = () => {
        if(storedCredentials.language == 'English') {
            return EnglishStrings
        } else if(storedCredentials.language == 'Arabic') {
            return ArabicStrings
        } else return PersianStrings
    }

    return (
        <CredentialsContext.Consumer >
            {({storedCredentials})=> (
            <NavigationContainer  independent={true}>
                <Stack.Navigator>
                    {storedCredentials
                        ?(
                            <>
                                {/* <Stack.Screen name="Home" component={Home} />    */}
                                <Stack.Screen 
                                    name="Home" 
                                    key={1} 
                                    options={{
                                        title: strings().updating ,
                                        headerTitleAlign: 'center',
                                        headerTitleStyle: { fontSize: 25, fontFamily: fontsLoaded ? "Mikhak-Bold" : "" },
                                        headerStyle: { backgroundColor: storedCredentials.theme == "light" ? '#f2f2f2' : '#3b3c37' },
                                        headerRight: (props) => <Entypo name="menu" size={35} color={storedCredentials.theme == "light" ? 'black' : 'white' } />,
                                        headerLeft: (props) => <Ionicons name="add-circle-outline" size={40} color={storedCredentials.theme == "light" ? 'black' : 'white' } />,
                                        headerTintColor: storedCredentials.theme == "light" ? 'blue' : '#e88804',
                                        animationEnabled: false,
                                        freezeOnBlur: true,

                                        
                                    }}
                                    
                                >
                                    {rootStackProps =>  <Home {...rootStackProps} buttomNavNavigation = {props.navigation} socket={{sendMessage: props.socket.sendMessage, lastMessage: props.socket.lastMessage, readyState: props.socket.readyState}} isTokenValidated = {props.isTokenValidated}  token = {props.token}/> }
                                </Stack.Screen>   
                                <Stack.Screen 
                                    name="Room Modules" 
                                    key={2}
                                    options={{
                                        title: strings().updating,
                                        headerTitleAlign: 'center',
                                        headerTitleStyle: { fontSize: 25, fontFamily: fontsLoaded ? "Mikhak-Bold" : ""  },
                                        headerStyle: { backgroundColor: storedCredentials.theme == "light" ? '#f2f2f2' : '#3b3c37' },
                                        headerTintColor: storedCredentials.theme == "light" ? 'black' : 'white',
                                        animationEnabled: false,
                                        freezeOnBlur: true

                                    }}
                                >
                                    {rootStackProps => <MaterialTopTabNav {...rootStackProps} socket={{sendMessage: props.socket.sendMessage, lastMessage: props.socket.lastMessage, readyState: props.socket.readyState}} isTokenValidated={props.isTokenValidated} token = {props.token} /> }
                                </Stack.Screen>
                                {/* <Stack.Screen name='Fetch Room ' component={FetchRoom} /> */}
                                <Stack.Screen 
                                    name='Fetch Room ' 
                                    key={3}
                                > 
                                    {props =>  <FetchRoom {...props} /> }
                                </Stack.Screen>
                                {/* <Stack.Screen name='Settings' component={Settings} /> */}
                                <Stack.Screen 
                                    name='Settings' 
                                    key={4}
                                    options={{
                                        animationEnabled: false,

                                    }}
                                >
                                    {props=>  <Settings {...props} /> }
                                </Stack.Screen>
                            </>
                            
                        ):(
                            <>
                                {/* <Stack.Screen name="Sign Up" component={SignUp} /> */}
                                <Stack.Screen name='Sign UP' key={5}>
                                    {props=> <SignUp {...props} />}
                                </Stack.Screen>
                                {/* <Stack.Screen name="Activation with SMS" component={ActivationWithSMS} /> */}
                                <Stack.Screen name="Activation with SMS" key={6}>
                                    {props=> <ActivationWithSMS {...props} />}
                                </Stack.Screen>
                                
                            </>
                    )}
                    
                </Stack.Navigator>
            </NavigationContainer>    
            )}
        </CredentialsContext.Consumer>
    )

    // return (
    //     <CredentialsContext.Consumer >
    //         {({storedCredentials})=> (
    //         <NavigationContainer>
    //             <Stack.Navigator initialRouteName="Sign Up">
    //                 {storedCredentials
    //                 ?(
    //                     <>

    //                         <Stack.Screen name="Home" component={Home} />   
    //                         <Stack.Screen name="Room Modules" component={RoomModules} />
    //                         <Stack.Screen name='Fetch Room ' component={FetchRoom} />
    //                         <Stack.Screen name='Settings' component={Settings} />
    //                     </>
    //                 ):(
    //                     <>
    //                         <Stack.Screen name="Sign Up" component={SignUp} />
    //                         {/* <Stack.Screen name="Sign In" component={SignIn} /> */}
    //                         <Stack.Screen name="Activation with SMS" component={ActivationWithSMS} />
    //                     </>
    //                 )}
                    
    //             </Stack.Navigator>
    //         </NavigationContainer>    
    //         )}
    //     </CredentialsContext.Consumer>
    // )
};

export default RootStack;